import { useLocation } from "react-router-dom";

const PageNotFound = () => {

	return <> 
	<h3 className="text-center">Eva's times tables - beat the clock</h3>
	<div style={{textAlign:'center', marginTop:'20px'}}>
		<a href="./"><button className="btn btn-primary btn-lg">Back To Menu</button></a>
		<h1 style={{fontSize:'50px', marginTop:'40px'}}>404</h1>	
	</div>
	<div style={{textAlign:'center'}}>
		<h1 style={{fontSize:'30px'}}>Page not found </h1>
	</div>
	
	
	</>;
  };
  
  export default PageNotFound;